<div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 label-container" *ngIf="label">
  <label [ngClass]="{ required: isRequired }">{{ label }}</label>
</div>
<div class="ui-g-6 ui-xl-6 ui-lg-6 ui-md-12 ui-sm-12 ui-xs-12">
  <span class="p-input-icon-right">
    <input
      class="doc-submit-inputs"
      [class]="fileData.filename != null ? 'clearable-text' : ''"
      pInputText
      type="text"
      name="{{ inputName }}Title"
      [(ngModel)]="fileData.filename"
      #{{inputName}}Title="ngModel"
      readonly
      [required]="isRequired" />
    <button
      *ngIf="fileData.filename"
      class="clear-btn"
      type="button"
      (click)="clearInput()"
      pButton
      icon="pi pi-times"
      [disabled]="isClearButtonDisabled"></button>
  </span>
</div>
<div class="ui-g-3 ui-xl-3 ui-lg-3 ui-md-12 ui-sm-12 ui-xs-12 upload-button">
  <p-fileUpload
    *ngIf="!isDetailsView"
    chooseLabel="{{ 'facilities-data.form-fields.upload-button' | translate }}"
    name="uploader"
    #uploader
    (onSelect)="onSelectFile($event, uploader)"
    mode="basic"
    [disabled]="isUploadDisabled"></p-fileUpload>
  <button
    *ngIf="isDetailsView && fileData.filename"
    (click)="previewDocument()"
    class="view-btn-width view-btn"
    label="{{ 'view-button-label' | translate }}"
    pButton
    type="button"></button>
</div>
<p-toast></p-toast>
